var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.232,
    height: 14.103,
    viewBox: "0 0 25.232 14.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18579",
    "data-name": "Group 18579",
    transform: "translate(12968.731 -9722.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "push_pin_FILL1_wght500_GRAD0_opsz24",
    d: "M238.129-846.882l1.2,1.375v1.568h-3.047v4.109l-.684.782-.684-.782v-4.109h-3.047v-1.568l1.2-1.375v-4.705h-.6v-1.564h6.26v1.564h-.6Z",
    transform: "translate(-13200.601 10575.982)",
    fill: "#394960"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4670",
    "data-name": "Line 4670",
    x2: 24,
    transform: "translate(-12967.5 9728.167)",
    fill: "none",
    stroke: "#394960",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPin);
export default __webpack_public_path__ + "static/media/left-pin.b6d724b1640ff9f0556ec9aec2fbb329.svg";
export { ForwardRef as ReactComponent };